<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'450px'"
    :classDialog="'node-dialog'"
    :offsetTop="'25vh'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">Thông tin ban hành</h3>
      <div class="listInfoNode">
        <el-form label-position="right" label-width="120px">
          <el-form-item label="Đơn vị ban hành: ">
            <el-input
              :value="publisherName"
              placeholder="_"
              disabled
              size="medium"
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
          <el-form-item label="Thời gian nhận: ">
            <el-input
              :value="convertTimeToString(doc.createTime)"
              placeholder="_"
              disabled
              size="medium"
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
  import dateFormatter from "../../../filters/dateFormatter";

  export default {
    name: "process-moreinfo-banhanh",
    props: ["isOpen", "doc"],
    components: {
      DialogTemplate: () => import("../../common/custom-dialog.vue")
    },

    computed: {
      publisherName() {
        return this.doc.publisherName || this.doc.outsidePublisherName;
      }
    },

    methods: {
      convertTimeToString(value) {
        return dateFormatter(value);
      }
    },

  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/components/process-moreinfo-banhanh.vue